<script setup lang="ts">
import NavItemSearch from './nav-item-search.vue';
import NavItemCasino from './nav-item-casino.vue';
import NavItemLiveCasino from './nav-item-live-casino.vue';
import NavItemPromos from './nav-item-promos.vue';
import NavItemSportBetting from './nav-item-sport-betting.vue';
import model from '@/ts/model';
import { globalBlurLogic } from '@/ts/management/ui-management';
import MobileNavBottomLines from './assets/mobile-nav-bottom-top-lines.svg?raw';
</script>

<template>
    <template v-if="model.view != 'gameplay'">
        <div class="mobile-nav-bottom-upper-border" :class="{blur: globalBlurLogic}" v-html="MobileNavBottomLines"></div>
        <div class="mobile-nav-bottom" :class="{blur: globalBlurLogic}">
            <div class="inner">
                <nav-item-search />
                <nav-item-casino />
                <nav-item-live-casino />
                <nav-item-sport-betting />
                <nav-item-promos />
            </div>
        </div>
    </template>
</template>

<style lang="scss" scoped>
@use '@/scss/shared';
.mobile-nav-bottom{
    display:flex;
    background: linear-gradient(0deg, #212426 0%, #0A0A0A 100%);
    mask-image: url(./assets/mask-group.png);
    mask-size: 100% 100%;
    mask-repeat: no-repeat;
    mask-position: center bottom;
    mask-repeat: no-repeat;
    & > .inner{
        display: flex;
        flex: 1;
        box-sizing: border-box;
        justify-content: space-around;
        align-items: center top;
    }
    &,
    &-upper-border{
        position: fixed;
        z-index: 100;
        width: 100%;
        height: 90px;
        bottom: 0;
        left: 0;
        &.blur{
            opacity: .35;
            // filter: blur(10px);
            mask-image: none !important;
        }
    }
    &-upper-border{
        z-index: 101;
        pointer-events: none;
        height: 25px;
        bottom: 70px;
        @include shared.site() using($site-key){
            color: shared.theme-color("comp3_2", $site-key);
        }
        & > *{
            width:100%;
        }
    }
}
</style>